// 搜尋頁 - 結果列表＋廣告欄位
'use client';

import { useState, useEffect } from 'react';

import SearchKeyword from './SearchKeyword'; // 關鍵字、結果數量顯示
import SearchTabButton from './SearchTabButton'; // 結果分類按鈕
import SearchResultList from './SearchResultList'; // 結果列表
import ListAsideAd from '@/components/advertisement/ListAsideAd'; // 側邊廣告欄位
import SearchEmptyResult from './SearchEmptyResult'; // 無搜尋結果
import GoTop from '../layout/GoTop'; // 一鍵往上

import { searchNews } from '@/app/actions';

const SearchResultWrapper = ({
    locale,
    initSearchResult = [],
    pageCnt,
    keyword,
    banners,
    initAmount,
}) => {
    const [isMount, setIsMount] = useState(false);
    // 目前分類
    const [currentType, setCurrentType] = useState('ALL');
    // 結果列表
    const [resultList, setResultList] = useState(initSearchResult);
    // 頁碼
    const [pageIndex, setPageIndex] = useState(1);
    // 總頁數
    const [pageSize, setPageSize] = useState(pageCnt);
    // 結果數量
    const [resultAmount, setResultAmount] = useState(initAmount);

    // 取得更多搜尋
    const fetchMoreNews = async (page) => {
        try {
            const { news, totalPage, totalSize } = await searchNews({
                locale,
                page,
                keyword,
                category1: currentType !== 'ALL' ? currentType.toLowerCase() : null,
            });
            if (news) {
                setResultList(news);
                setPageSize(totalPage);
                setResultAmount(totalSize);
                window.scrollTo({ top: 0 });
            }
        } catch (e) {
            console.error(e);
        }
    };

    const onTypeChange = () => {
        setPageIndex(1);
        fetchMoreNews(1);
    };

    useEffect(() => {
        if (isMount) fetchMoreNews(pageIndex);

        setIsMount(true);
    }, [pageIndex]);

    useEffect(() => {
        if (isMount) onTypeChange();
    }, [currentType]);

    return (
        <>
            {/* 關鍵字＋結果數量 */}
            <SearchKeyword keyword={keyword} resultAmount={resultAmount} />

            <section
                className={
                    (resultList?.length < 3 || pageSize < 2) && resultList?.length
                        ? 'pb-[50px]'
                        : ''
                }
            >
                {/* 結果分類按鈕 */}
                <SearchTabButton currentType={currentType} setCurrentType={setCurrentType} />

                {/* 分隔線 */}
                <hr className="w-full border-t-1 border-black2 border-opacity-[.3]" />

                <div
                    className={`px-[30px] mx-auto pt-[15px] flex gap-x-[15px] usm:px-[15px] 
                        max-w-[1240px] ${
                            pageSize < 2 && resultList?.length < 3 ? 'pb-[20px] ulg:pb-[15px]' : ''
                        }`}
                >
                    {resultList?.length ? (
                        //  結果列表
                        <SearchResultList
                            pageIndex={pageIndex}
                            setPageIndex={setPageIndex}
                            pageSize={pageSize}
                            resultList={resultList}
                        />
                    ) : (
                        // 搜尋空值
                        <SearchEmptyResult />
                    )}

                    <aside className="flex flex-col uxl:hidden">
                        {/* 側邊廣告欄位 */}
                        <ListAsideAd position="search" banners={banners} />

                        {/* 一鍵往上 */}
                        <GoTop />
                    </aside>
                </div>
            </section>
        </>
    );
};

export default SearchResultWrapper;
